import type { RouterUseQueryOptions } from '@newfront-insurance/data-layer-client';
import type { SuccessfulResult } from '@newfront-insurance/data-layer-http';
import type { RouterQueryInput, RouterQueryOutput } from '@newfront-insurance/data-layer-server';

import { useAdminTRPC } from '../../../shared/providers/trpc';
import type { SharedRouter } from '../../../shared/trpc/router';

type EmployeesQueryResult = RouterQueryOutput<SharedRouter, 'employees.getAllByUserUuids'>;
export type Employees = SuccessfulResult<EmployeesQueryResult>;
export type Employee = Employees[number];

export function useEmployeesByUserUuids(
  params: RouterQueryInput<SharedRouter, 'employees.getAllByUserUuids'>,
  options?: RouterUseQueryOptions<SharedRouter, 'employees.getAllByUserUuids'>,
) {
  const { useQuery } = useAdminTRPC();

  return useQuery(['employees.getAllByUserUuids', params], options);
}
